import React from 'react';
import config from '../config';
import DashboardInitializer from '../dashboards/DashboardInitializer';
import apiPaths from '../apiPaths';

const EducadorDashboard = (props) => {
  const components = [
    {
      params: {
        type: 'search',
        componentId: 'educadoreducadorSearch',
        panelHeader: 'Educador',
        panelKey: 'educadoreducadorSearch',
        yPosition: 0,
        xPosition: 0,
        width: 24,
        collapsible: true,
        collapsed: false,
        isTabItem: false,
        tabIndex: 0,
        tabTitle: '',
      },
      groups: [
        {
          index: 0,
          title: '',
          mustRender: true,
          subgroups: [
            {
              index: 0,
              title: '',
              mustRender: true,
              yPosition: 0,
              xPosition: 0,
              width: 24,
              fields: [
                {
                  key: 'username',
                  yPosition: 1,
                  xPosition: 1,
                  mustRender: true,
                  width: 8,
                },
                {
                  key: 'admin',
                  yPosition: 1,
                  xPosition: 2,
                  mustRender: true,
                  width: 8,
                },
                {
                  key: 'fkEscuela.id',
                  yPosition: 1,
                  xPosition: 3,
                  mustRender: true,
                  width: 8,
                },
              ],
            },
          ],
        },
      ],
      fields: [
        {
          title: 'Usuari',
          key: 'username',
          type: 'text',
          operand: 'like',
          validationType: 'text',
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Administrador',
          key: 'admin',
          type: 'comboCustom',
          comboId: 'corporate',
          operand: 'like',
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Escola',
          key: 'fkEscuela.id',
          type: 'combo',
          comboId: 'escuela',
          operand: 'like',
          mandatory: false,
          disabled: false,
        },
      ],
      settings: {
        fieldSize: config.COMPONENT.FORM.FIELD_SIZE,
        fieldGutter: config.COMPONENT.FORM.FIELD_MARGIN,
      },
    },
    {
      params: {
        type: 'table',
        componentId: 'educadoreducadorList',
        rowKey: 'id',
        panelHeader: 'Educador',
        panelKey: 'educadoreducadorList',
        navigationParams: props.query.params.q || '',
        yPosition: 1,
        xPosition: 0,
        width: 24,
        collapsible: true,
        collapsed: false,
        isTabItem: false,
        tabTitle: '',
        isMainTable: true,
        tabIndex: 0,
        tableType: 0,
      },
      fields: [
        {
          title: 'Id',
          dataIndex: 'id',
          position: 0,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
          width: 60,
        },
        {
          title: 'Nom',
          dataIndex: 'nombre',
          position: 1,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
        },
        {
          title: 'Cognoms',
          dataIndex: 'apellidos',
          position: 2,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
        },
        {
          title: 'Usuari',
          dataIndex: 'username',
          position: 3,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
        },
        {
          title: 'Contrasenya',
          dataIndex: 'password',
          position: 4,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
        },
        {
          title: 'Administrador',
          dataIndex: 'admin',
          position: 5,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
          render: 'comboCustom',
          comboId: 'corporate',
        },

        {
          title: 'Escola',
          dataIndex: 'fkEscuela.nombre',
          position: 6,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
        },
      ],
      settings: {
        size: config.COMPONENT.TABLE.SIZE,
        bordered: config.COMPONENT.TABLE.BORDERED,
        editable: true,
        multiple: false,
        canCreate: true,
        canDelete: true,
        scroll: { x: true },
      },
      pagination: {
        defaultPageSize: 50,
        pageSizeOptions: ['5', '10', '20', '50'],
        showQuickJumper: config.COMPONENT.SHOW_QUICK_JUMPER,
        showSizeChanger: config.COMPONENT.TABLE.SHOW_SIZE_CHANGER,
        showTotal: config.COMPONENT.TABLE.SHOW_TOTAL,
        size: config.COMPONENT.TABLE.SIZE,
      },
    },
    {
      params: {
        type: 'edit',
        componentId: 'educadoreducadorEdit',
        panelHeader: 'Educador',
        panelKey: 'educadoreducadorEdit',
        primaryKey: 'id',
        yPosition: 2,
        xPosition: 0,
        width: 24,
        collapsible: true,
        collapsed: false,
        isTabItem: true,
        tabIndex: 0,
        tabTitle: 'Educador',
      },
      groups: [
        {
          index: 0,
          title: '',
          mustRender: true,
          subgroups: [
            {
              index: 2,
              title: '',
              mustRender: true,
              yPosition: 0,
              xPosition: 0,
              width: 24,
              fields: [
                {
                  key: 'nombre',
                  yPosition: 1,
                  xPosition: 1,
                  mustRender: true,
                  width: 12,
                },
                {
                  key: 'apellidos',
                  yPosition: 1,
                  xPosition: 2,
                  mustRender: true,
                  width: 12,
                },
                {
                  key: 'fkEscuela.id',
                  yPosition: 2,
                  xPosition: 1,
                  mustRender: true,
                  width: 12,
                },
                {
                  key: 'admin',
                  yPosition: 2,
                  xPosition: 2,
                  mustRender: true,
                  width: 12,
                },
                {
                  key: 'username',
                  yPosition: 3,
                  xPosition: 1,
                  mustRender: true,
                  width: 12,
                },
                {
                  key: 'password',
                  yPosition: 3,
                  xPosition: 2,
                  mustRender: true,
                  width: 12,
                },
              ],
            },
          ],
        },
      ],
      fields: [
        {
          title: 'Nom',
          key: 'nombre',
          type: 'text',
          unique: false,
          validationType: 'text',
          mandatory: true,
          disabled: false,
        },
        {
          title: 'Cognoms',
          key: 'apellidos',
          type: 'text',
          unique: false,
          validationType: 'text',
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Escola',
          key: 'fkEscuela.id',
          type: 'combo',
          comboId: 'escuela',
          operand: 'like',
          unique: false,
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Administrador',
          key: 'admin',
          type: 'comboCustom',
          comboId: 'corporate',
          mandatory: true,
          disabled: false,
          initialValue: true,
        },
        {
          title: 'Usuari',
          key: 'username',
          type: 'text',
          unique: false,
          mandatory: true,
          disabled: false,
        },
        {
          title: 'Contrasenya',
          key: 'password',
          type: 'text',
          unique: false,
          validationType: 'text',
          initialMandatory: true,
          initialVisibility: true,
          behaviours: [
            [
              {
                key: 'admin',
                value: false,
                operand: 'like',
                type: 'visible',
              },
              {
                key: 'admin',
                value: false,
                operand: 'like',
                type: 'mandatory',
              },
            ],
          ],
        },
      ],
      settings: {
        fieldSize: config.COMPONENT.FORM.FIELD_SIZE,
        fieldGutter: config.COMPONENT.FORM.FIELD_MARGIN,
        canEdit: true,
        canCreate: true,
        canDelete: true,
      },
    },
  ];

  const componentId = 'EducadorDashboard';

  return (
    <DashboardInitializer
      componentId={componentId}
      components={components}
      {...props}
    />
  );
};

export default EducadorDashboard;
